import {Pipe, PipeTransform} from '@angular/core';
import {ValueFromAdditionalMapPipe} from './value-from-additional-map.pipe';
import {ServerConstants} from '../model/ServerConstants';
import {TopLevelDomainVO} from '../generate/TopLevelDomainVO';

@Pipe({
    name: 'pendingRequestIdExtractor',
    standalone: false
})
export class PendingRequestIdExtractorPipe implements PipeTransform {
  constructor() {
  }

  transform(domain: TopLevelDomainVO, editChangeRequestMode: boolean, requestID: string, field: string): string {
    const valuesFromMap: ValueFromAdditionalMapPipe = new ValueFromAdditionalMapPipe();
    const properties = domain.locks ? domain : domain.additionalProperties;
    const rawValue = valuesFromMap.transform(properties, ServerConstants.LOCK_FIELD_NAME, field);
    const pendingRequestIds: string[] = Array.isArray(rawValue) ? rawValue : (rawValue ? [rawValue] : []);

    if (!editChangeRequestMode) {
      return pendingRequestIds.join(', ');
    } else {
      const editRequestBlockedSections = [ServerConstants.AUTH_POLICY_FIELD_NAME, ServerConstants.NAME_SERVERS_FIELD_NAME, ServerConstants.TRUST_ANCHORS_FIELD_NAME];
      if (!pendingRequestIds.includes(requestID) || editRequestBlockedSections.includes(field)) {
        return 'XXXXXX'; // returning some value to fill pendingrequest id - hack for edit change request mode
      } else {
        return '';
      }
    }
  }

}
